// Copyright (c) 2022 by Move Closer

import { Module } from 'vuex'

import { State } from '../shared/contracts/store'

import { WishlistState, MutationType, WishListModel } from './contract'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const storeFactory = (): Module<WishlistState, State> => ({
  namespaced: true,

  state: () => ({
    wishlist: null
  }),

  mutations: {
    [MutationType.SetWishlist] (state, wishlist: WishListModel): void {
      state.wishlist = wishlist
    }
  },

  getters: {
    /**
     * Returns the identifier of cart.
     */
    wishlist: (state) => state.wishlist
  }
})
